import { render, staticRenderFns } from "./MyCourseSchedule.vue?vue&type=template&id=5dea8fa7&"
import script from "./MyCourseSchedule.vue?vue&type=script&lang=js&"
export * from "./MyCourseSchedule.vue?vue&type=script&lang=js&"
import style0 from "./MyCourseSchedule.vue?vue&type=style&index=0&id=5dea8fa7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports